const TurksAndCaicosSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112629)">
      <path
        d="M40 20C40 31.0456 31.0456 40 20 40C8.95437 40 0 31.0456 0 20C0 20.0048 20 0.0021875 20 0C31.0456 0 40 8.95437 40 20Z"
        fill="#0052B4"
      />
      <path
        d="M19.9468 19.9998H20.0003C20.0003 19.9818 20.0003 19.9643 20.0003 19.9463C19.9825 19.9642 19.9647 19.982 19.9468 19.9998Z"
        fill="#F0F0F0"
      />
      <path
        d="M20 10.4348C20 6.91563 20 4.60977 20 0H19.9966C8.95242 0.001875 0 8.95539 0 20H10.4348V14.1241L16.3106 20H19.9466C19.9644 19.9822 19.9822 19.9644 20.0001 19.9465C20.0001 18.5991 20.0001 17.3968 20.0001 16.3108L14.1241 10.4348H20Z"
        fill="#F0F0F0"
      />
      <path
        d="M10.1181 2.6084C6.99004 4.38957 4.38949 6.99004 2.6084 10.1181V19.9997H7.82582V7.82598V7.82582H19.9997C19.9997 6.18027 19.9997 4.61262 19.9997 2.6084H10.1181Z"
        fill="#D80027"
      />
      <path
        d="M19.9993 17.5403L12.8935 10.4346H10.4341V10.4347L19.9992 19.9997H19.9993C19.9993 19.9997 19.9993 18.3039 19.9993 17.5403Z"
        fill="#D80027"
      />
      <path
        d="M22.6084 10.4346V19.9997C22.6084 24.6591 28.6954 26.0868 28.6954 26.0868C28.6954 26.0868 34.7823 24.6591 34.7823 19.9997V10.4346H22.6084Z"
        fill="#FFDA44"
      />
      <path
        d="M27.8259 13.912C27.8259 14.8725 27.0473 17.3903 26.0868 17.3903C25.1262 17.3903 24.3477 14.8725 24.3477 13.912C24.3477 12.9514 26.0868 12.1729 26.0868 12.1729C26.0868 12.1729 27.8259 12.9514 27.8259 13.912Z"
        fill="#FF9811"
      />
      <path
        d="M32.4412 15.8061C32.7218 15.1214 32.9401 14.1204 32.9401 13.6221C32.9401 12.8217 31.8965 12.1729 31.8965 12.1729C31.8965 12.1729 30.853 12.8218 30.853 13.6221C30.853 14.1204 31.0713 15.1214 31.3519 15.8061L30.7495 17.1663C31.1036 17.3102 31.4906 17.3902 31.8965 17.3902C32.3023 17.3902 32.6894 17.3102 33.0434 17.1663L32.4412 15.8061Z"
        fill="#A2001D"
      />
      <path
        d="M27.391 19.9994C27.391 19.9994 26.5215 21.7386 26.5215 23.4777H30.8693C30.8692 21.7386 29.9997 19.9994 29.9997 19.9994L28.6953 19.1299L27.391 19.9994Z"
        fill="#6DA544"
      />
      <path
        d="M29.9994 19.9989V19.5641C29.9994 18.8438 29.4154 18.2598 28.695 18.2598C27.9747 18.2598 27.3906 18.8437 27.3906 19.5641V19.9989H29.9994Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112629">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default TurksAndCaicosSvg;
